import routes from 'src/routes';

import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';

import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import './i18n';
import socketIO from 'socket.io-client';
import { backendBaseURL } from './utils/properties';

export const socket = socketIO(backendBaseURL);

function App() {
  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <CssBaseline />
        {routes()}
      </LocalizationProvider>
    </ThemeProvider>
  );
}
export default App;
